import React from "react";
import Header from "./Header/Header";
import { HeaderNav, Menu } from "./Header/Header";
import { Col, Navbar } from "react-bootstrap";
import { Link } from "react-router-dom";

const DisputesHeaderDark = (props) => {
  return (
    <>
      <Header
        topSpace={{ md: true }}
        type="reverse-scroll border-b border-[#ffffff1a]"
      >

            
        <HeaderNav
          fluid="fluid"
          theme="dark"
          expand="lg"
          className="py-[16px] px-[35px] lg:pr-[35px] md:px-0 md:py-[20px] "
        >
          <Col className="col-9 col-xl-3 col-lg-3 col-sm-9 col-xs-9 me-auto ps-lg-0 ps-0 ps-md-3">
            <Link
              aria-label="header home link"
              className="flex items-center"
              to="/"
              data-test="logo"
            >
              <Navbar.Brand className="inline-block p-0 m-0">
                <img
                  className="default-logo"
                  height="160"
                  loading="lazy"
                  src="/assets/img/1.png"
                  alt="logo"
                />
                <img
                  className="alt-logo"
                  height="160"
                  loading="lazy"
                  src="/assets/img/2.png"
                  alt="logo"
                />
                <img
                  className="mobile-logo"
                  height="36"
                  width="100"
                  loading="lazy"
                  src="/assets/img/2.png"
                  alt="logo"
                />
              </Navbar.Brand>
            </Link>
          </Col>
          <Navbar.Toggle className="order-last md:mx-[20px] sm:ml-[15px] sm:mr-0">
            <span className="navbar-toggler-line"></span>
            <span className="navbar-toggler-line"></span>
            <span className="navbar-toggler-line"></span>
            <span className="navbar-toggler-line"></span>
          </Navbar.Toggle>
          <Navbar.Collapse className="col-auto menu-order px-lg-0 justify-end">
            <Menu {...props} />
          </Navbar.Collapse>
        </HeaderNav>
        
      </Header>
    </>
  );
};

export default DisputesHeaderDark;
